import React from 'react';

function Cuba(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124157)">
        <mask
          id="mask0_800_124157"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124157)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#3D58DB"
          />
          <mask
            id="mask1_800_124157"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124157)">
            <path
              d="M0 8H-2V10V14V16H0H36H38V14V10V8H36H0Z"
              fill="#3D58DB"
              stroke="#F7FCFF"
              strokeWidth="4"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24L20.25 12L0 0Z"
            fill="#E31D1C"
          />
          <mask
            id="mask2_800_124157"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="21"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24L20.25 12L0 0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_800_124157)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.52384 14.2168L3.39292 16.1548L5.40404 12.2609L2.84131 10.1808L6.00535 10.077L7.52384 6.55627L8.68265 10.077H11.8413L9.73599 12.2609L11.4106 16.1548L7.52384 14.2168Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124157">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Cuba;
